<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YdbKCz/tc-custom/9780062484550.jpg?1718184629306" alt="This image is the cover for the book Unlikely Story of a Pig in the City"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Unlikely Story of a Pig in the City
      </h1>
      <p class="bookDescription body article font2">
        <b>A “heartwarming and satisfying” middle grade novel about a young city girl’s adventure as she searches for a forever home for a pig (<i>Booklist</i>).</b><br/><br/>Josie Shilling’s too-big family lives in a too-small city house, and sometimes she feels invisible. But all that changes when her brother brings home a tiny piglet he rescued from a farm. Her name is Hamlet. And the moment Josie holds her, she feels an instant bond.<br/><br/>But there’s no room for Hamlet in the crowded Shilling household. And whoever heard of keeping a pig in the city? So it’s up to Josie to find her a forever home. Along the way, she’ll learn what it really means to grow bigger when you’ve always felt small.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jodi Kendall
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6303dcb7